import { createVoiceOrchestrator } from './createVoiceOrchestrator'

export function publishVoiceChatEvent(orchestrator, event) {
  orchestrator?.publish(event)
}

export { createVoiceOrchestrator }
